import React from 'react';
import { Icon, Button, Card, Descriptions, Spin } from 'antd';
import OutletList from './OutletList';
import { useMerchantOnboardHook } from './hooks/useMerchantOnboardHook';
const SectionTitle = ({ icon, children }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    {icon && <Icon type={icon} />}
    <h4 style={{ margin: 0 }}>{children}</h4>
  </div>
);
const MerchantOnboardDetails = () => {
  const {
    loading,
    data,
    onAccept,
    onReject,
    setSelectedSerials,
    selectedSerials,
    allSerialNumbersSelected,
  } = useMerchantOnboardHook();
  if (loading || !data) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Spin size="large" tip="Loading merchant details..." />
      </div>
    );
  }
  return (
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h6 style={{ margin: 0 }}>Merchant Details Page</h6>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            type="primary"
            icon={<Icon type="check" />}
            onClick={onAccept}
            disabled={!allSerialNumbersSelected}
          >
            Accept Changes
          </Button>
          {/* <Button type="danger" icon={<Icon type="close" />} onClick={onReject}>
            Reject Changes
          </Button> */}
        </div>
      </div>
      <Card title={<SectionTitle icon="shop">Merchant Details</SectionTitle>}>
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Merchant Code">{data?.merchant?.code}</Descriptions.Item>
          <Descriptions.Item label="Name">{data?.merchant?.name}</Descriptions.Item>
          <Descriptions.Item label="Address">{data?.merchant?.address}</Descriptions.Item>
          <Descriptions.Item label="Email">{data?.merchant?.email}</Descriptions.Item>
          <Descriptions.Item label="Contact Person">
            {data?.merchant?.contactPerson}
          </Descriptions.Item>
          <Descriptions.Item label="Contact Number">
            {data?.merchant?.contactNumber}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <Card
        title={<SectionTitle icon="database">Outlets ({data?.outlets?.length} total)</SectionTitle>}
      >
        {data?.outlets?.map((o, idx) => (
          <OutletList
            outlet={o}
            index={idx}
            setSelectedSerials={setSelectedSerials}
            selectedSerials={selectedSerials}
          />
        ))}
      </Card>
    </div>
  );
};

export default MerchantOnboardDetails;
